import React from 'react';
import DynaModal from "../Modal/DynaModal";
import DynaTable from "../MyTable/DynaTable";
import NumericFunction from "../../utils/NumericFunction";

const ModalDetailFollowUp = ({onClose, dataDetailModal}) => {

    return (
        <DynaModal onClose={onClose} className={'simple-modal-saden'}>

            <div className="header-modal">
                <p>جزییات پیگیری</p>

                <div onClick={onClose}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M9.16936 15.5801C8.97936 15.5801 8.78938 15.5101 8.63938 15.3601C8.34938 15.0701 8.34938 14.5901 8.63938 14.3001L14.2994 8.64011C14.5894 8.35011 15.0694 8.35011 15.3594 8.64011C15.6494 8.93011 15.6494 9.41011 15.3594 9.70011L9.69936 15.3601C9.55936 15.5101 9.35936 15.5801 9.16936 15.5801Z"
                            fill="white"/>
                        <path
                            d="M14.8294 15.5801C14.6394 15.5801 14.4494 15.5101 14.2994 15.3601L8.63938 9.70011C8.34938 9.41011 8.34938 8.93011 8.63938 8.64011C8.92937 8.35011 9.40936 8.35011 9.69936 8.64011L15.3594 14.3001C15.6494 14.5901 15.6494 15.0701 15.3594 15.3601C15.2094 15.5101 15.0194 15.5801 14.8294 15.5801Z"
                            fill="white"/>
                        <path
                            d="M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H15C20.43 1.25 22.75 3.57 22.75 9V15C22.75 20.43 20.43 22.75 15 22.75ZM9 2.75C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V9C21.25 4.39 19.61 2.75 15 2.75H9Z"
                            fill="white"/>
                    </svg>
                </div>
            </div>

            <div className="content-modal full-width">
                <div className="top-content-one-row">
                    <div className="inline-row my-set-co">
                        <span> کاربر ارسال کننده :
                            <p>{dataDetailModal?.KMO}</p>
                        </span>

                        <span>تاریخ ارسال :
                            <p>{NumericFunction.e2p(dataDetailModal?.DDATE + " - " + dataDetailModal?.TTIME)}</p>
                        </span>

                        <div className="svg-side">

                            <div className="one-svg-box">
                                <svg width="15" height="15" viewBox="0 0 15 15" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <g clip-path="url(#clip0_769_518)">
                                        <path
                                            d="M5.62441 11.0937C5.36816 11.0937 5.15566 10.8812 5.15566 10.625V8.00624L4.70566 8.45624C4.52441 8.63749 4.22441 8.63749 4.04316 8.45624C3.86191 8.27499 3.86191 7.97499 4.04316 7.79374L5.29316 6.54374C5.42441 6.41249 5.63066 6.36874 5.80566 6.44374C5.98066 6.51249 6.09316 6.68749 6.09316 6.87499V10.625C6.09316 10.8812 5.88066 11.0937 5.62441 11.0937Z"
                                            fill="#1B9C85"/>
                                        <path
                                            d="M6.87445 8.59368C6.7557 8.59368 6.63695 8.54993 6.5432 8.45618L5.29316 7.20618C5.11191 7.02493 5.11191 6.72493 5.29316 6.54368C5.47441 6.36243 5.77441 6.36243 5.95566 6.54368L7.2057 7.79368C7.38695 7.97493 7.38695 8.27493 7.2057 8.45618C7.11195 8.54993 6.9932 8.59368 6.87445 8.59368Z"
                                            fill="#1B9C85"/>
                                        <path
                                            d="M9.375 14.2188H5.625C2.23125 14.2188 0.78125 12.7688 0.78125 9.375V5.625C0.78125 2.23125 2.23125 0.78125 5.625 0.78125H8.75C9.00625 0.78125 9.21875 0.99375 9.21875 1.25C9.21875 1.50625 9.00625 1.71875 8.75 1.71875H5.625C2.74375 1.71875 1.71875 2.74375 1.71875 5.625V9.375C1.71875 12.2563 2.74375 13.2812 5.625 13.2812H9.375C12.2563 13.2812 13.2812 12.2563 13.2812 9.375V6.25C13.2812 5.99375 13.4937 5.78125 13.75 5.78125C14.0063 5.78125 14.2188 5.99375 14.2188 6.25V9.375C14.2188 12.7688 12.7688 14.2188 9.375 14.2188Z"
                                            fill="#1B9C85"/>
                                        <path
                                            d="M13.75 6.71875H11.25C9.1125 6.71875 8.28125 5.88749 8.28125 3.74999V1.24999C8.28125 1.06249 8.39375 0.887493 8.56875 0.818743C8.74375 0.743743 8.94375 0.787493 9.08125 0.918743L14.0813 5.91874C14.2125 6.04999 14.2563 6.25625 14.1813 6.43125C14.1063 6.60625 13.9375 6.71875 13.75 6.71875ZM9.21875 2.38124V3.74999C9.21875 5.36249 9.6375 5.78124 11.25 5.78124H12.6188L9.21875 2.38124Z"
                                            fill="#1B9C85"/>
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_769_518">
                                            <rect width="15" height="15" fill="white"/>
                                        </clipPath>
                                    </defs>
                                </svg>
                                <p>{NumericFunction.e2p(dataDetailModal?.AC)}</p>
                            </div>

                            <div className="one-svg-box">
                                <svg width="15" height="15" viewBox="0 0 15 15" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M7.49969 10.2062C6.00596 10.2062 4.79346 8.99369 4.79346 7.49994C4.79346 6.0062 6.00596 4.7937 7.49969 4.7937C8.99344 4.7937 10.2059 6.0062 10.2059 7.49994C10.2059 8.99369 8.99344 10.2062 7.49969 10.2062ZM7.49969 5.7312C6.52469 5.7312 5.73096 6.52494 5.73096 7.49994C5.73096 8.47494 6.52469 9.26869 7.49969 9.26869C8.47469 9.26869 9.26844 8.47494 9.26844 7.49994C9.26844 6.52494 8.47469 5.7312 7.49969 5.7312Z"
                                        fill="#32A692"/>
                                    <path
                                        d="M7.50031 13.1375C5.15029 13.1375 2.93154 11.7625 1.40654 9.375C0.744043 8.34375 0.744043 6.6625 1.40654 5.62499C2.93779 3.23749 5.15654 1.86249 7.50031 1.86249C9.84406 1.86249 12.0628 3.23749 13.5878 5.62499C14.2503 6.65625 14.2503 8.3375 13.5878 9.375C12.0628 11.7625 9.84406 13.1375 7.50031 13.1375ZM7.50031 2.79999C5.48154 2.79999 3.55029 4.01249 2.20029 6.13124C1.73154 6.8625 1.73154 8.1375 2.20029 8.86875C3.55029 10.9875 5.48154 12.2 7.50031 12.2C9.51906 12.2 11.4503 10.9875 12.8003 8.86875C13.2691 8.1375 13.2691 6.8625 12.8003 6.13124C11.4503 4.01249 9.51906 2.79999 7.50031 2.79999Z"
                                        fill="#32A692"/>
                                </svg>
                                <p>{NumericFunction.e2p(dataDetailModal?.BC)}</p>
                            </div>

                            <div className="one-svg-box">
                                <svg width="15" height="15" viewBox="0 0 15 15" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <g clip-path="url(#clip0_769_512)">
                                        <path
                                            d="M9.375 14.2188H5.625C2.23125 14.2188 0.78125 12.7688 0.78125 9.375V5.625C0.78125 2.23125 2.23125 0.78125 5.625 0.78125H9.375C12.7688 0.78125 14.2188 2.23125 14.2188 5.625V9.375C14.2188 12.7688 12.7688 14.2188 9.375 14.2188ZM5.625 1.71875C2.74375 1.71875 1.71875 2.74375 1.71875 5.625V9.375C1.71875 12.2563 2.74375 13.2812 5.625 13.2812H9.375C12.2563 13.2812 13.2812 12.2563 13.2812 9.375V5.625C13.2812 2.74375 12.2563 1.71875 9.375 1.71875H5.625Z"
                                            fill="#32A692"/>
                                        <path
                                            d="M6.61195 9.73756C6.48695 9.73756 6.3682 9.68756 6.2807 9.60006L4.51191 7.83131C4.33066 7.65006 4.33066 7.35006 4.51191 7.16881C4.69316 6.98756 4.99316 6.98756 5.17441 7.16881L6.61195 8.60631L9.82444 5.39381C10.0057 5.21256 10.3057 5.21256 10.4869 5.39381C10.6682 5.57506 10.6682 5.87506 10.4869 6.05631L6.9432 9.60006C6.8557 9.68756 6.73695 9.73756 6.61195 9.73756Z"
                                            fill="#32A692"/>
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_769_512">
                                            <rect width="15" height="15" fill="white"/>
                                        </clipPath>
                                    </defs>
                                </svg>
                                <p>{NumericFunction.e2p(dataDetailModal?.CC)}</p>
                            </div>
                        </div>
                    </div>

                </div>

                <div className="table-modal-content">
                    {dataDetailModal?.followUpDetails.data.length > 0 &&
                        <DynaTable
                            column={dataDetailModal?.followUpDetails?.column}
                            data={dataDetailModal?.followUpDetails?.data}
                            className={"solid-table"}
                            onRowClick={() => {
                            }}
                            mainWidth={'100%'}/>
                    }
                </div>

            </div>
        </DynaModal>
    );
};
export default ModalDetailFollowUp;